import { SHOW_LOADER, HIDE_LOADER } from './../constants/actionTypes'

const loader = (store = 0, action = {}) => {
  switch (action.type) {
    case SHOW_LOADER:
      return store + 1
    case HIDE_LOADER:
      return store - 1
    default:
      return store
  }
}

export default loader
